import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Link } from "./../util/router";
import { useAuth } from "../util/auth";

function SettingsNav(props) {
  const auth = useAuth();

  return (
    <Tabs
      value={props.activeKey}
      indicatorColor="primary"
      textColor="primary"
      centered={true}
    >
      <Tab
        component={Link}
        to="/settings/general"
        label="General"
        value="general"
      />
      <Tab
        component={Link}
        to="/settings/security"
        label="security"
        value="security"
        disabled={!auth.rawUser.emailVerified}
      />
      <Tab
        component={Link}
        to="/settings/billing"
        label="Billing"
        value="billing"
        disabled={auth?.user?.userType !== 'production' || !auth.rawUser.emailVerified}
      />
    </Tabs>
  );
}

export default SettingsNav;
